import {
  provideKeycloak,
  createInterceptorCondition,
  IncludeBearerTokenCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  AutoRefreshTokenService,
  UserActivityService,
  withAutoRefreshToken
} from 'keycloak-angular';
import { AppConfigInterface } from './config/app.config.interface';

export const provideKeycloakAngular = (config: AppConfigInterface) =>
  provideKeycloak({
    config: {
      realm: 'portal',
      url: config.apiURL + 'auth',
      clientId: config.keycloakClientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      checkLoginIframe: true,
      pkceMethod: 'S256',
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      redirectUri: window.location.origin + '/',
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: 600000,
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [createInterceptorCondition<IncludeBearerTokenCondition>({
          urlPattern: config.apiUrlInterceptor,
          httpMethods: ['GET', 'POST'],
          bearerPrefix: 'Bearer',
        })],
      },
    ],
  });
